// The polite live region of the shell. Features announce through useAnnounce(): "9 Zellen geprüft",
// a page change, the end of an upload. Progress is summarised, never announced per cell (ARCHITECTURE 19.4).

import { createContext, useCallback, useContext, useState, type ReactNode } from "react";

type Announce = (message: string) => void;

const AnnounceContext = createContext<Announce>(() => undefined);

export function useAnnounce(): Announce {
  return useContext(AnnounceContext);
}

export function LiveRegionProvider({ children }: { children: ReactNode }) {
  const [current, setCurrent] = useState<{ id: number; text: string } | null>(null);
  // A new element for every message: the same sentence twice in a row is announced twice.
  const announce = useCallback<Announce>((text) => {
    setCurrent((previous) => ({ id: (previous?.id ?? 0) + 1, text }));
  }, []);

  return (
    <AnnounceContext.Provider value={announce}>
      {children}
      <div className="sf-visually-hidden" role="status" aria-live="polite" aria-atomic="true">
        {current !== null && <span key={current.id}>{current.text}</span>}
      </div>
    </AnnounceContext.Provider>
  );
}
